import api from './api';

// 뉴스 관련 API 호출 함수들
export const playlistApi = {
  // 플레이리스트 목록 조회 (전체)
  getAllPlaylists: async (sortBy = 'popular', page = 1, size = 20, config = {}) => {
    const response = await api.getPublic(`/lists?sort=${sortBy}&page=${page}&size=${size}`, config);
    return response.data;
  },

  // 앨범 플레이리스트 목록 조회
  getAlbumPlaylists: async (sortBy = 'popular', page = 1, size = 20) => {
    const response = await api.getPublic(
      `/lists?type=album&sort=${sortBy}&page=${page}&size=${size}`,
    );
    return response.data;
  },

  // 트랙 플레이리스트 목록 조회
  getTrackPlaylists: async (sortBy = 'popular', page = 1, size = 20) => {
    const response = await api.getPublic(
      `/lists?type=track&sort=${sortBy}&page=${page}&size=${size}`,
    );
    return response.data;
  },

  // 플레이리스트 상세 조회
  getPlaylistById: async (id, { optionalAuth = false, ...config } = {}) => {
    const response = await (optionalAuth ? api.getAuth : api.getPublic)(`lists/${id}`, config);
    return response.data;
  },

  // 슬러그로 플레이리스트 상세 조회
  getPlaylistBySlug: async (slug, { optionalAuth = false, ...config } = {}) => {
    const response = await (optionalAuth ? api.getAuth : api.getPublic)(
      `lists/by-slug/${slug}`,
      config,
    );
    return response.data;
  },

  // 플레이리스트 생성
  createPlaylist: async (playlistData, config = {}) => {
    const response = await api.postAuth('/lists', playlistData, config);
    return response.data;
  },

  // 플레이리스트 업데이트
  updatePlaylist: async (id, playlistData, config = {}) => {
    const response = await api.putAuth(`/lists/${id}`, playlistData, config);
    return response.data;
  },

  // 플레이리스트 삭제
  deletePlaylist: async (id, config = {}) => {
    const response = await api.deleteAuth(`/lists/${id}`, config);
    return response.data;
  },

  // 플레이리스트 댓글 작성
  addComment: async (playlistId, content, parentId = null, mentionedUserId = null) => {
    const payload = {
      articleType: 'PLAY_LIST',
      articleId: Number(playlistId),
      content: content,
    };

    if (parentId !== null) {
      payload.parentId = parentId;
    }
    if (mentionedUserId !== null) {
      payload.mentionedUserId = mentionedUserId;
    }

    const response = await api.postAuth('/comments', payload);
    return response.data;
  },

  // 플레이리스트 북마크 추가
  addBookmark: async (playlistId, config = {}) => {
    const response = await api.postAuth(
      '/bookmarks',
      {
        itemType: 'PLAY_LIST',
        itemId: Number(playlistId),
      },
      config,
    );
    return response.data;
  },

  // 플레이리스트 북마크 삭제
  deleteBookmark: async (playlistId, config = {}) => {
    const response = await api.deleteAuth(`/bookmarks/play_list/${playlistId}`, config);
    return response.data;
  },
};
